export default [
  {
    path: "qyyxList", // 全员营销列表页面
    name: "qyyxList",
    component: resolve => require(["../views/market/qyyx/list.vue"], resolve)
  },
  {
    path: "qyyxRanking", // 全员营销排行页面
    name: "qyyxRanking",
    component: resolve => require(["../views/market/qyyx/ranking.vue"], resolve)
  },
  {
    path: "qyyxRankingstaff/:aid/:orgid", // 全员营销排行详情页面
    name: "qyyxRankingStaff",
    component: resolve =>
      require(["../views/market/qyyx/RankingStaff.vue"], resolve)
  },
  {
    path: "smsIndex", // 短信列表页面
    name: "smsIndex",
    component: resolve => require(["../views/market/sms/index.vue"], resolve)
  },
  {
    path: "smsSend", // 发送短信页面
    name: "smsSend",
    component: resolve => require(["../views/market/sms/send.vue"], resolve)
  },
  {
    path: "smsTemplate", // 短信模板
    name: "smsTemplate",
    component: resolve => require(["../views/market/sms/template.vue"], resolve)
  },
  {
    path: "smsReport/:id", // 短信报表
    name: "smsReport",
    component: resolve => require(["../views/market/sms/report.vue"], resolve)
  },
  {
    path: "smsReportDetail/:reid/:reportid/:index", // 短信报表
    name: "smsReportDetail",
    component: resolve =>
      require(["../views/market/sms/report-detail.vue"], resolve)
  },
  {
    path: "smsAiGenerate", // AI生成短信
    name: "smsAiGenerate",
    component: resolve => require(["../views/market/sms/AiGenerate.vue"], resolve)
  },

  {
    path: "automatic", 
    name: "automatic",
    component: resolve => require(["../views/market/automatic/list.vue"], resolve)
  },
  {
    path: "autoReport/:id", 
    name: "autoReport",
    component: resolve => require(["../views/market/automatic/SmsReport.vue"], resolve)
  },
  {
    path: "automaticadd/:id", 
    name: "automaticadd",
    component: resolve => require(["../views/market/automatic/add.vue"], resolve)
  },
];
